import {
  BackgroundColor,
  SectionTitle,
  SectionTitleBody,
  SectionTitleHeading
} from "@silversea-ssc/ui-components-react";
import { CruisesSliderHitsProps } from "components/Algolia/CruisesSliderHits";
import React from "react";
import { Trans } from "@lingui/react/macro";
import TrendingItemsCruisesSlider from "./TrendingItemsCruisesSlider";

type DestinationCruisesSliderProps = Pick<
  CruisesSliderHitsProps,
  "promosContent" | "shipsContent"
> & {
  destinationWebCode: string | undefined;
  backgroundColor: BackgroundColor;
};

const DestinationCruisesSlider: React.FC<DestinationCruisesSliderProps> = (
  props
) => {
  return (
    <TrendingItemsCruisesSlider {...props}>
      <SectionTitle variant="wide">
        <SectionTitleHeading>
          <Trans>Best Sellers</Trans>
        </SectionTitleHeading>
        <SectionTitleBody>
          <Trans>
            Only our best selling voyages. Go further and delve deeper into the
            authentic beauty of destinations you’ve always dreamed of visiting.
          </Trans>
        </SectionTitleBody>
      </SectionTitle>
    </TrendingItemsCruisesSlider>
  );
};

export default DestinationCruisesSlider;
